import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";

import App from "./App";

if (process.env.NODE_ENV === "production") {
  disableReactDevTools();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
